/* eslint-disable */
export default `<li class="search-events__item">

    <span class="search-events__date-comp <%= data.isInPlay ? 'wh-hide' : '' %>">
        <%= data.startDate %><%= data.competitionName ? ', ' + data.competitionName : '' %>
    </span>

    <a class="search-events__name" href="<%= data.url %>" aria-label="<%= data.name %> <%= data.startDate %> <%= data.competitionName ? ', ' + data.competitionName : '' %>"><%= data.name %></a>

    <span class="search-events__streaming wh-label <%= !data.streamingAvailable ? 'wh-hide' : '' %>"><i
            class="icon-tv"></i>WHTV</span>

    <span class="search-events__inplay wh-label <%= !data.isInPlay ? 'wh-hide' : '' %>"><i class="icon-in-play"></i><%= translator.translate('components.misc.search.live') %></span>

    <%= data.marketTemplate ? data.marketTemplate : '' %>

</li>`;
